import { memo } from 'react';

import {
  ProfileDetails,
  type ProfileDetailsGameplayHeaderProps,
} from '@/features/profile/components/profileDetails';
import { Card } from '@/shared/components/ui/card';
import { Skeleton } from '@/shared/components/ui/skeleton';

export type ProfileGameplaySkeletonProps = ProfileDetailsGameplayHeaderProps;

export const ProfileGameplaySkeleton = memo(function ProfileGameplaySkeleton(
  props: ProfileGameplaySkeletonProps,
) {
  return (
    <ProfileDetails.Gameplay.Root>
      <ProfileDetails.Gameplay.Header {...props} />
      <div className="flex items-center gap-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-5 w-8" />
      </div>
      <Card variant="data">
        <Skeleton className="mb-3 h-4 w-16" />
        <div className="grid grid-cols-2 gap-3">
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-14 w-full" />
        </div>
      </Card>
      <Card variant="data">
        <Skeleton className="mb-3 h-4 w-32" />
        <Skeleton className="h-20 w-full" />
      </Card>
      <Card variant="data">
        <Skeleton className="mb-3 h-4 w-24" />
        <div className="grid grid-cols-2 gap-x-2 gap-y-3">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </Card>
      <Card variant="data">
        <Skeleton className="mb-3 h-4 w-28" />
        <div className="flex flex-col gap-3">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </Card>
      <Card variant="data">
        <Skeleton className="h-4 w-24" />
      </Card>
    </ProfileDetails.Gameplay.Root>
  );
});
